exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.offer-search-results[data-v-d4f7a8aa] {\n  overflow: auto;\n  margin-bottom: 10px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/OfferSearchResults.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,oBAAoB;CACrB","file":"OfferSearchResults.vue","sourcesContent":["\n.offer-search-results[data-v-d4f7a8aa] {\n  overflow: auto;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d4f7a8aa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OfferSearchResults.vue
// module id = lDLy
// module chunks = 1